import config from '../config';
import { buildFetchOptions, convertToSearchParams } from '../common';

const prepRequest = ({ accessToken, environment, body, method }) => {
    const options = buildFetchOptions({ accessToken, body, method });

    const { subscriptionsUrl } = config[environment];
    const baseUrl = `${subscriptionsUrl}/v1/subscriptions`;

    return { options, baseUrl };
  };

export const getSubscription = async (id, accessToken, environment)  => {
    const { baseUrl, options } = prepRequest({accessToken, environment});
    const fullUrl = `${baseUrl}/${id}`;

    const res = await fetch(fullUrl, options);

    if (!res.ok) {
      throw res;
    }

    return res.json();
  };

export const getSubscriptions = async ({ resourceId = '', resourceType = '', filter }, accessToken, environment) => {
    const { baseUrl, options } = prepRequest({accessToken, environment});
    const fullUrl = baseUrl + convertToSearchParams({ resourceId, resourceType });

    const res = await fetch(fullUrl, options);
    if (!res.ok) {
      throw res;
    }

    const { subscriptions } = await res.json();
    return filter ? subscriptions.filter(filter) : subscriptions;
  };

export const postSubscription = async (subscription, accessToken, environment) => {
    const { baseUrl, options } = prepRequest({ accessToken, body: subscription, environment });
    const res = await fetch(baseUrl, options);

    if (!res.ok) {
      throw res;
    }

    return res.json();
  };

export const deleteSubscription = async (id, accessToken, environment) => {
    const { baseUrl, options } = prepRequest({ accessToken, environment, method: 'DELETE' });
    const fullUrl = `${baseUrl}/${id}`;
    const res = await fetch(fullUrl, options);

    if (!res.ok) {
      throw res;
    }
  };

export const deleteSubscriptionByResourceType = async (resourceType, accessToken, environment) => {
    const { baseUrl, options } = prepRequest({ accessToken, environment, method: 'DELETE' });
    const fullUrl = baseUrl + convertToSearchParams({ resourceType });
    const res = await fetch(fullUrl, options);

    if (!res.ok) {
      throw res;
    }
  };
